module.exports = __webpack_public_path__ + "img/right.24de0f75.png";